import { Component } from 'react';

export default abstract class BaseComponent<
  P = {},
  S = {},
  SS = any
> extends Component<P, S, SS> {}
